import { useMemo } from 'react';

import { useClientController_RangeLiceReport } from '@/services/hooks';
import type { RangeReportResult } from '@/services/types';

import type { DomainQueryOptions } from '../shared/types';

import { mapRangeReportResultToDomain } from './mappers';
import type { UseGetLocationRangeLiceReportResult } from './types';

export const useGetLocationRangeLiceReport = (
    clientId: number,
    locationId: number,
    from: string,
    to: string,
    options?: DomainQueryOptions<RangeReportResult>
): UseGetLocationRangeLiceReportResult => {
    const query = useClientController_RangeLiceReport(clientId, { locationId, from, to }, options);

    const rangeReport = useMemo(() => {
        if (!query.data?.data) return null;
        return mapRangeReportResultToDomain(query.data.data);
    }, [query.data?.data]);

    return {
        data: rangeReport,
        isLoading: query.isPending,
        isFetching: query.isFetching,
        isFetched: query.isFetched,
        error: query.error,
        refetch: query.refetch,
    };
};
